import React, { useEffect } from 'react';
import BusySpinner from '../spinners/BusySpinner';
import getClientConfig from '../../utils/getClientConfig';
import { getIdToken, clearAllTokens } from '../../utils/tokenStorage';

function LogoutPage() {
  const { aiEndSessionUrl, enableAvalaraIdentityJwt } = getClientConfig();

  useEffect(() => {
    const performLogout = () => {
      const idToken = getIdToken();

      delete sessionStorage.token;
      sessionStorage.removeItem('code_verifier');
      sessionStorage.removeItem('auth_state');
      sessionStorage.clear();

      delete localStorage.mvrCustomerId;
      delete localStorage.masqueradeUser;
      delete localStorage.uuid;

      clearAllTokens();

      if (window.appConfig) {
        window.appConfig.featureFlags = {};
      }

      if (enableAvalaraIdentityJwt && aiEndSessionUrl) {
        const postLogoutRedirectUri = window.location.origin;
        let redirectUrl = `${aiEndSessionUrl}?post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`;
        
        if (idToken) {
          redirectUrl += `&id_token_hint=${encodeURIComponent(idToken)}`;
        }
        
        window.location.href = redirectUrl;
      } else {
        window.location.href = window.location.origin;
      }
    };

    performLogout();
  }, [aiEndSessionUrl, enableAvalaraIdentityJwt]);

  return <BusySpinner busy={true} />;
}

export default LogoutPage;
